<script lang="ts">
import { Button, FormGroup, Label } from "sveltestrap";

import type { Parking } from "../Model/Parking";
import type { Zone } from "../Model/Zone";
import { parkingService, parkingStorageService, zonesService } from "../services";
import ChronoTime from "./ChronoTime.svelte";
import ClientBar from "./ClientBar.svelte";
import EndParkingModal from "./EndParkingModal.svelte";
import ScheduleText from "./ScheduleText.svelte";


export let parking: Parking;
let timePark: Date;
let openModal: boolean = false;
let zone: Zone;
let showInfo: Boolean = false;

$: getParkingActual(parking);


async function getParkingActual(parking){
  zone = await zonesService.getZone(parking.zoneId);

  timePark = new Date(parking.parkingDate); 

  showInfo = true;
  
}

async function endToParking(){
  if (!confirm('¿Esta seguro de querer dejar el aparcamiento?')) return;
  
  if(!await parkingService.endToParking(parking.id)){
    return;
  }

  parkingStorageService.deleteParkingToMap(parking.id);

  openModal = true;
  
}

</script>

<style lang="scss">

    .control-html{
        position: relative;
        width: 100vw;
        display: flex;
        align-items: center;
        flex-direction: column;
        max-width: 450px;
        margin: auto;
        background-color: #BAD9FF;
    }

    .chrono-time-number{
        color: #0E3CA5;
        background-color: #fff;
        min-height: 100px;
        text-align: center;
        font-size: 65px;
        font-weight: bold;
        text-align: center;
        width: 100%;
        
        p{
            font-size: 15px !important;
        }
    }

    .body-html {
        position: relative;
        padding-top: 20px;
        padding-bottom: 20px;
        max-width: 360px;
        width: 100%;
        margin: auto;
        display: flex;
        flex-direction: column;
        justify-content: space-between;

        .info-car{
            color: #0E3CA5;
            width: 85%;
            background-color: #fff;
            padding: 15px;
            border-radius: 10px;
            margin: auto;

            h1{
                font-size: 20px;
            }

            a{
                display: block;
                text-decoration: none;
                color: #0E3CA5;
                border: #0E3CA5 1px solid;
                border-radius: 10px;
                align-items: center;
                padding: 5px;
                font-style: italic;
                font-size: 20px;
            }
        }
    }

    :global(#button-parking-ko){
        width: 85%;
        margin: auto;
        display: block;
        background-color: #34A853;
        border-color: #34A853;
        min-height: 45px;
        font-size: 20px;
        font-weight: bold;
        border-radius: 10px;
    }

</style>



<div class="control-html">
    <ClientBar />

    <div class="chrono-time-number">
        <h1 class="mt-3 mb-0">Tiempo restante</h1>
        {#if timePark}
          <ChronoTime parkTime={timePark} zoneId={zone.id} />
          <p> TIEMPO MÁXIMO DE ESTACIONAMIENTO   <strong>{zone.time} m.</strong></p> 
        {/if}
    </div>

    <div class="body-html">
        <div class="chrono-time-block">
          {#if showInfo}
            <div class="info-car">
              <FormGroup>
                <h1>Datos del vehículo</h1>
                <p>Matrícula: {parking.plate}</p>
              </FormGroup>
              <FormGroup>
                <h1>Datos del aparcamiento</h1>
                <p class="mb-0">Hora de llegada: {timePark.getHours() + ':' +timePark.getMinutes() + ', ' + timePark.getDay() + '/' + timePark.getMonth() + '/' + timePark.getFullYear()}</p>
                <p class="mb-0">Zona: {zone.name}</p>
                <p class="mb-0">Horario: </p>
                <ScheduleText schedule={zone.schedule} />
              </FormGroup>
              <div class="text-center">
                <a target="_blank" href="https://maps.google.com/?q={parking.coordinates.lat},{parking.coordinates.lon}">¿Cómo llegar?</a>
              </div>
              
            </div>
          {/if}
        </div>

        <div class="text-end mt-4">
            <Button id="button-parking-ko" type="button" color=primary on:click={endToParking}>Retirar vehículo</Button>
        </div>
    </div>
  
</div>


<EndParkingModal open={openModal} on:parkingSolved />